/**
 * Any one of the values should be present in the .env file
 * [REACT_APP_PROJECT_ENV=dev | qa | uat | prod]
 * If not present, dev instance will be used
 */

export const instances = {
	dev: 'dev',
	qa: 'qa',
	staging: 'uat',
	prod: 'prod',
	poc: 'poc',
};

const config = {
	[instances.dev]: {
		API_ENDPOINT: 'https://diabetes-api-dev.joinwecare.dev/api/v1/',
		WEB_ENDPOINT: 'https://wecare-dev.joinwecare.dev/api/v1/',
		MIXPANEL_TOKEN: 'a095caf5d9fde4050c0bc0605b098ed6',
	},
	[instances.qa]: {
		API_ENDPOINT: 'https://diabetes-api-qa.joinwecare.dev/api/v1/',
		WEB_ENDPOINT: 'https://wecare-qa.joinwecare.dev/api/v1/',
		MIXPANEL_TOKEN: '775906cdc5d829686c0a0f27f44793fd',
	},
	[instances.prod]: {
		API_ENDPOINT: 'https://wc-api.joinwecare.app/api/v1/',
		WEB_ENDPOINT: 'https://wecare-uat.joinwecare.dev/api/v1/',
		MIXPANEL_TOKEN: 'f2a97a8f75525a479762c030bb876f11',
	},
};

export default {
	currentInstance: process.env.REACT_APP_PROJECT_ENV || instances.dev,
	sentryDSN: process.env.REACT_APP_SENTRY_DSN || '',
	// MIXPANEL_TOKEN:process.env.REACT_APP_MIX_PANEL_TOKEN || '',
	mixPanelToken() {
		return config[this.currentInstance].MIXPANEL_TOKEN;
	},
	latestAppVersion: '1.4.b108',
	baseURL() {
		return config[this.currentInstance].API_ENDPOINT;
	},
};
